import { getSegmentDefault } from "../segment/segmentState";
import * as types from "./mutationTypes";

export default {
  [types.SET_INTERACTIONS](state, interactions) {
    state.interactions = interactions;
  },
  [types.CLEAR_INTERACTIONS](state) {
    state.interactions = null;
  },
  [types.SET_TOTAL_INTERACTIONS](state, total) {
    state.totalInteractions = total;
  },
  [types.CLEAR_TOTAL_INTERACTIONS](state) {
    state.totalInteractions = null;
  },
  [types.SET_INTERACTION_CATEGORIES](state, categories) {
    state.interactionCategories = categories;
  },
  [types.CLEAR_INTERACTION_CATEGORIES](state) {
    state.interactionCategories = null;
  },
  [types.SET_FILTER_INTERACTIONS](state, filter) {
    state.filter = filter;
  },
  [types.CLEAR_FILTER_INTERACTIONS](state) {
    state.filter = getSegmentDefault().rules.static;
  }
};
